import { render, staticRenderFns } from "./MessageRowResource.vue?vue&type=template&id=0612956a&scoped=true&"
import script from "./MessageRowResource.vue?vue&type=script&lang=js&"
export * from "./MessageRowResource.vue?vue&type=script&lang=js&"
import style0 from "./MessageRowResource.vue?vue&type=style&index=0&id=0612956a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612956a",
  null
  
)

export default component.exports